import { render, staticRenderFns } from "./ComponenteDialogoReporteTecnico.vue?vue&type=template&id=40acfb08&scoped=true&"
import script from "./ComponenteDialogoReporteTecnico.vue?vue&type=script&lang=ts&"
export * from "./ComponenteDialogoReporteTecnico.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteDialogoReporteTecnico.vue?vue&type=style&index=0&id=40acfb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40acfb08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40acfb08', component.options)
    } else {
      api.reload('40acfb08', component.options)
    }
    module.hot.accept("./ComponenteDialogoReporteTecnico.vue?vue&type=template&id=40acfb08&scoped=true&", function () {
      api.rerender('40acfb08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Devoluciones/ComponenteDialogoReporteTecnico.vue"
export default component.exports